import { EFeedbackModalOption } from './_types';

export const FEEDBACK_MODAL_OPTIONS: Array<EFeedbackModalOption> =
  Object.values(EFeedbackModalOption) as Array<EFeedbackModalOption>;

export const OPTION = {
  [EFeedbackModalOption.NOT_ACTUAL]: 'options.NOT_ACTUAL',
  [EFeedbackModalOption.CAN_NOT_UNDERSTAND]: 'options.CAN_NOT_UNDERSTAND',
  [EFeedbackModalOption.HARD_TO_UNDERSTAND]: 'options.HARD_TO_UNDERSTAND',
  [EFeedbackModalOption.USELESS]: 'options.USELESS',
} as const;
